// import { theme } from 'antd';

// Ant Design 主题配置
export const antdTheme = {
  token: {
    // 主色调 - 音频系统绿色
    colorPrimary: '#10b981',
    colorPrimaryHover: '#059669',
    colorPrimaryActive: '#047857',
    
    // 圆角
    borderRadius: 12,
    borderRadiusLG: 16,
    borderRadiusSM: 8,
    
    // 背景色
    colorBgContainer: 'rgba(255, 255, 255, 0.95)',
    colorBgElevated: 'rgba(255, 255, 255, 0.98)',
    
    // 文字颜色
    colorText: '#1f2937',
    colorTextSecondary: '#6b7280',
    colorTextTertiary: '#9ca3af',
    
    // 边框颜色
    colorBorder: 'rgba(0, 0, 0, 0.1)',
    colorBorderSecondary: 'rgba(0, 0, 0, 0.05)',
    
    // 阴影
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    boxShadowSecondary: '0 2px 8px rgba(0, 0, 0, 0.08)',
    
    // 字体
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: 14,
    fontSizeLG: 16,
    fontSizeSM: 12,
    
    // 间距
    padding: 16,
    paddingLG: 24,
    paddingSM: 12,
    paddingXS: 8,
    
    // 动画
    motionDurationFast: '0.1s',
    motionDurationMid: '0.2s',
    motionDurationSlow: '0.3s',
  },
  
  components: {
    // 卡片组件
    Card: {
      borderRadius: 16,
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
      paddingLG: 20,
      padding: 16,
    },
    
    // 按钮组件
    Button: {
      borderRadius: 12,
      paddingInline: 24,
      paddingBlock: 8,
      fontSize: 14,
      fontWeight: 500,
    },
    
    // 滑块组件
    Slider: {
      trackBg: '#e5e7eb',
      trackHoverBg: '#d1d5db',
      handleSize: 20,
      handleSizeHover: 24,
    },
    
    // 开关组件
    Switch: {
      borderRadius: 12,
      handleSize: 20,
    },
    
    // 输入框组件
    Input: {
      borderRadius: 8,
      paddingInline: 12,
      paddingBlock: 8,
    },
    
    // 空间组件
    Space: {
      size: 16,
      sizeSmall: 8,
      sizeMiddle: 16,
      sizeLarge: 24,
    },
  },
};

// 响应式断点配置
export const breakpoints = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
};

// 音频系统专用颜色
export const audioColors = {
  // 主色调
  primary: '#10b981',
  primaryHover: '#059669',
  primaryActive: '#047857',
  
  // 状态颜色
  success: '#10b981',
  warning: '#f59e0b',
  error: '#ef4444',
  info: '#3b82f6',
  
  // 音频相关颜色
  audioWave: '#10b981',
  audioPeak: '#ef4444',
  audioBackground: '#f3f4f6',
  audioGrid: '#e5e7eb',
  
  // 频谱颜色
  spectrumLow: '#10b981',
  spectrumMid: '#f59e0b',
  spectrumHigh: '#ef4444',
  
  // 连接状态颜色
  connected: '#10b981',
  disconnected: '#ef4444',
  connecting: '#f59e0b',
  
  // 设备状态颜色
  deviceOnline: '#10b981',
  deviceOffline: '#6b7280',
  deviceError: '#ef4444',
};

// 音频系统专用尺寸
export const audioSizes = {
  // 移动端尺寸
  mobile: {
    cardPadding: 16,
    buttonHeight: 44,
    inputHeight: 44,
    sliderHeight: 20,
    iconSize: 20,
    fontSize: 14,
    borderRadius: 12,
  },
  
  // 桌面端尺寸
  desktop: {
    cardPadding: 24,
    buttonHeight: 36,
    inputHeight: 32,
    sliderHeight: 16,
    iconSize: 16,
    fontSize: 14,
    borderRadius: 8,
  },
  
  // 平板端尺寸
  tablet: {
    cardPadding: 20,
    buttonHeight: 40,
    inputHeight: 38,
    sliderHeight: 18,
    iconSize: 18,
    fontSize: 14,
    borderRadius: 10,
  },
};

// 音频系统专用间距
export const audioSpacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
};

// 音频系统专用动画
export const audioAnimations = {
  // 脉冲动画（用于连接状态）
  pulse: {
    keyframes: `
      0% { opacity: 1; }
      50% { opacity: 0.5; }
      100% { opacity: 1; }
    `,
    duration: '2s',
    timing: 'ease-in-out',
    iteration: 'infinite',
  },
  
  // 淡入动画
  fadeIn: {
    keyframes: `
      0% { opacity: 0; transform: translateY(10px); }
      100% { opacity: 1; transform: translateY(0); }
    `,
    duration: '0.3s',
    timing: 'ease-out',
  },
  
  // 缩放动画
  scale: {
    keyframes: `
      0% { transform: scale(1); }
      50% { transform: scale(1.05); }
      100% { transform: scale(1); }
    `,
    duration: '0.2s',
    timing: 'ease-in-out',
  },
};

// 深色主题配置
export const darkAntdTheme = {
  token: {
    // 主色调 - 音频系统绿色（深色模式下稍亮）
    colorPrimary: '#10b981',
    colorPrimaryHover: '#34d399',
    colorPrimaryActive: '#059669',
    
    // 圆角
    borderRadius: 12,
    borderRadiusLG: 16,
    borderRadiusSM: 8,
    
    // 背景色 - 深色模式
    colorBgContainer: '#1a1a1a',
    colorBgElevated: '#242424',
    colorBgLayout: '#0f0f0f',
    
    // 文字颜色 - 深色模式
    colorText: '#e5e5e5',
    colorTextSecondary: '#a3a3a3',
    colorTextTertiary: '#737373',
    
    // 边框颜色 - 深色模式
    colorBorder: 'rgba(255, 255, 255, 0.15)',
    colorBorderSecondary: 'rgba(255, 255, 255, 0.1)',
    
    // 阴影 - 深色模式
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
    boxShadowSecondary: '0 2px 8px rgba(0, 0, 0, 0.3)',
    
    // 字体
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: 14,
    fontSizeLG: 16,
    fontSizeSM: 12,
    
    // 间距
    padding: 16,
    paddingLG: 24,
    paddingSM: 12,
    paddingXS: 8,
    
    // 动画
    motionDurationFast: '0.1s',
    motionDurationMid: '0.2s',
    motionDurationSlow: '0.3s',
  },
  
  components: {
    // 卡片组件 - 深色模式
    Card: {
      borderRadius: 16,
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
      paddingLG: 20,
      padding: 16,
    },
    
    // 按钮组件 - 深色模式
    Button: {
      borderRadius: 12,
      paddingInline: 24,
      paddingBlock: 8,
      fontSize: 14,
      fontWeight: 500,
    },
    
    // 滑块组件 - 深色模式
    Slider: {
      trackBg: '#404040',
      trackHoverBg: '#525252',
      handleSize: 20,
      handleSizeHover: 24,
    },
    
    // 开关组件 - 深色模式
    Switch: {
      borderRadius: 12,
      handleSize: 20,
    },
    
    // 输入框组件 - 深色模式
    Input: {
      borderRadius: 8,
      paddingInline: 12,
      paddingBlock: 8,
    },
    
    // 空间组件
    Space: {
      size: 16,
      sizeSmall: 8,
      sizeMiddle: 16,
      sizeLarge: 24,
    },
  },
  algorithm: 'darkAlgorithm' as any, // Ant Design 5.x 深色模式算法
};

// 深色模式颜色系统
export const darkAudioColors = {
  // 主色调
  primary: '#10b981',
  primaryHover: '#34d399',
  primaryActive: '#059669',
  
  // 状态颜色
  success: '#10b981',
  warning: '#f59e0b',
  error: '#ef4444',
  info: '#3b82f6',
  
  // 音频相关颜色 - 深色模式
  audioWave: '#10b981',
  audioPeak: '#ef4444',
  audioBackground: '#1a1a1a',
  audioGrid: '#404040',
  
  // 频谱颜色 - 深色模式（更亮的颜色以保持可见性）
  spectrumLow: '#10b981',
  spectrumMid: '#f59e0b',
  spectrumHigh: '#ef4444',
  
  // 连接状态颜色
  connected: '#10b981',
  disconnected: '#ef4444',
  connecting: '#f59e0b',
  
  // 设备状态颜色
  deviceOnline: '#10b981',
  deviceOffline: '#737373',
  deviceError: '#ef4444',
};

// 导出主题配置
export const audioTheme = {
  antd: antdTheme,
  colors: audioColors,
  sizes: audioSizes,
  spacing: audioSpacing,
  animations: audioAnimations,
  breakpoints,
};

// 深色主题配置
export const darkAudioTheme = {
  antd: darkAntdTheme,
  colors: darkAudioColors,
  sizes: audioSizes,
  spacing: audioSpacing,
  animations: audioAnimations,
  breakpoints,
}; 